import ObjectExport from './container';

export default ObjectExport;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/index.js